import React from 'react';
import { useDispatch } from 'react-redux';

import { getCheckoutHref } from 'common/helpers/routerHelper';
import { createClubSignup } from 'redux/clubSignup/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

const Join = (props) => {
  const { club, joinText } = props;
  const { t } = useLocalization();
  const dispatch = useDispatch();

  const handleClick = () => {
    const onSuccess = () => {
      window.location.href = getCheckoutHref('/club');
    };
    dispatch(createClubSignup(club, onSuccess));
  };

  return (
    <a
      className="c7-btn c7-btn--primary"
      onClick={handleClick}
      onKeyPress={handleClick}
      role="link"
      data-testid={`${club.title}-join-club-button`}
      tabIndex="0"
      aria-label={t('general.accessibility.joinTheClub', {
        clubTitle: club.title
      })}
    >
      {joinText}
    </a>
  );
};

export default Join;
